import { render, staticRenderFns } from "./TantoEdit.vue?vue&type=template&id=d5e3720c&scoped=true&lang=pug&"
import script from "./TantoEdit.vue?vue&type=script&lang=coffee&"
export * from "./TantoEdit.vue?vue&type=script&lang=coffee&"
import style0 from "./TantoEdit.vue?vue&type=style&index=0&id=d5e3720c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e3720c",
  null
  
)

export default component.exports